//import { toDataURL } from 'qrcode'

const {reactive , onMounted, defineComponent} = Vue

jdw.vuex.Donate = {}
jdw.vuex.Donate.components = {}

if (jdw.isMob()) {
    const { Dialog ,RadioGroup ,Radio } = vant
    jdw.vuex.Donate.components[Dialog.name] = Dialog
    jdw.vuex.Donate.components[RadioGroup.name] = RadioGroup
    jdw.vuex.Donate.components[Radio.name] = Radio
}else{
    const {ElCarousel, ElCarouselItem, ElDialog,ElFormItem,ElRadioGroup, ElRadio, ElInput} = ElementPlus
    jdw.vuex.Donate.components.ElCarousel = ElCarousel
    jdw.vuex.Donate.components.ElCarouselItem = ElCarouselItem
    jdw.vuex.Donate.components.ElDialog = ElDialog  
    jdw.vuex.Donate.components.ElFormItem = ElFormItem  
    jdw.vuex.Donate.components.ElRadioGroup = ElRadioGroup  
    jdw.vuex.Donate.components.ElRadio = ElRadio 
    jdw.vuex.Donate.components.ElInput = ElInput
}

const Donate = defineComponent({
    name: "Donate",
    components: jdw.vuex.Donate.components,
    setup(props, context) {
        const data = reactive({
            tips: '推荐使用微信捐献或者登录后捐献，以帮助我们记住您的善举！',
            platform:'',        //默认为空，both
            user_id:'',
            pays:{
                wx:{
                    platform: 'wx',
                    name:'微信',
                    code: '',
                    url: '',
                    amount: '0.99',
                    input_amount: '0.99',
                },
                ali:{
                    platform: 'ali',
                    name:'支付宝',
                    code: '',
                    url: '',
                    amount: '0.99',
                    input_amount: '0.99',
                }
            },
            qtime: 0,
            msg: '',
            donates: '',        //捐助记录
            dialog_visible: false,
            //dialog_visible: true,
        })
        onMounted(()=>{
            console.log('donate.web.vue')
            getPayQRCode()
        })
        return {
            data,
            moreDonate,
            getPayQRCode,
            goDonate
        }
        function moreDonate(){
            data.dialog_visible = true
        }
        //【移动端】捐献
        function goDonate(){
            if(jdw.isShake())           return
            let total_amount;
            if (data.platform == "wx")                          total_amount = data.pays.wx.amount
            else if (data.platform == "ali")                    total_amount = data.pays.ali.amount
            else                                                total_amount = 0.99
            window.open(`/pay/wap/donate?platform=${data.platform}&amount=${total_amount}`);
        }
        function getPayQRCode()
        {
            if(jdw.isShake())           return
            let total_amount;
            if (data.platform == "wx")                          total_amount = data.pays.wx.input_amount
            else if (data.platform == "ali")                    total_amount = data.pays.ali.input_amount
            else                                                total_amount = 0.99
            if (!(data.user_id > 0) && data.qtime > 0)     layer.msg('建议登录后捐献，以帮助我们记住您的善举！')
            jdw.request({
                url: "/pay/web/donate",
                type: "post",
                dataType: "json",
                cache: true,
                data: {
                    platform: data.platform,
                    amount: total_amount,
                },
            }).then( res=>{
                console.log(res)
                data.qtime++;
                let res_data = jdw.getAjaxData(res)
                console.log(res_data)
                console.log(res_data.wx_code_url)
                if (res_data.wx_code_url != '') {
                    data.pays.wx.url = '';
                    data.pays.wx.code = res_data.wx_code_url;
                    data.pays.wx.amount = res_data.amount;
                    QRCode.toDataURL(data.pays.wx.code, function (err, url) {
                        console.log(url)
                        data.pays.wx.url = url
                    })
                }
                if (res_data.ali_code_url != '') {
                    data.pays.ali.url = '';
                    data.pays.ali.code = res_data.ali_code_url;
                    data.pays.ali.amount = res_data.amount;
                    $("#alipay_code_el").empty();
                    QRCode.toDataURL(data.pays.ali.code, function (err, url) {
                        console.log(url)
                        data.pays.ali.url = url
                    })
                }
                data.donates = res_data.donates;
                if (data.platform == '')       data.platform = 'wx';
            }).catch(err=>{
                console.log(err)
            })             
        }
    }
})
jdw.components.Donate = Donate
export default Donate